<template>
    <div class="app-box">
        <vue-scroll-snap @scroll="checkScroll" ref="scrollElement">
            <div class="item part-1" id="block1" ref="block1">
                <div class="app-box-header">
                    <div class="bg">
                        <div class="logs"><img src="/img/otc/otc-logos.png" /></div>
                        <div class="img-tips"><img src="/img/otc/otc-tips.png" /></div>
                        <div class="image-container">
                            <div v-for="(image, index) in images" :key="index" class="image-wrapper" :class="{
                                'selected': selectedIndex === index,
                                'unselected': selectedIndex !== null && selectedIndex !== index
                            }" @click="selectImage(index)">
                                <img :src="image.src" :alt="image.alt || `Image ${index + 1}`" class="image-item" />
                            </div>
                        </div>
                        <div class="menu-container">
                            <div v-for="(menu, index) in menuItems" :key="index" class="menu-item" :class="{
                                'selected': selectedIndex === index
                            }" :style="{ backgroundImage: menu.gradient }" @click="selectImage(index)" v-html="menu.name">
                                
                            </div>
                        </div>
                    </div>
                </div>

                <div class="app-box-bodyer-video" v-if="currMenusCode === 'blfrjn'">
                    <video controls playsinline autoplay muted loop class="video-box" ref="videoPlayer"
                        src="/video/otc/p-1.mp4"></video>
                    <img src="/img/otc/jl1.jpg" class="pro-img pro-img-jl1" />
                </div>

                <div class="app-box-bodyer-video" v-if="currMenusCode === 'blfhsj'">
                    <video controls playsinline autoplay muted loop class="video-box" ref="videoPlayer"
                        src="/video/otc/p-2.mp4"></video>
                    <img src="/img/otc/jin1.jpg" class="pro-img pro-img-jin1" />
                </div>

                <div class="app-box-bodyer-video" v-if="currMenusCode === 'blfjjp'">
                    <!-- <video controls playsinline autoplay muted loop class="video-box" ref="videoPlayer"
                        src="/video/otc/p-1.mp4"></video> -->
                    <img src="/img/otc/jj1.jpg" class="pro-img pro-img-jj1" />
                </div>

                <div class="app-box-bodyer-video" v-if="currMenusCode === 'blfkl'">
                    <!-- <video controls playsinline autoplay muted loop class="video-box" ref="videoPlayer"
                        src="/video/otc/p-1.mp4"></video> -->
                    <img src="/img/otc/kl1.jpg" class="pro-img pro-img-kl1" />
                </div>

                <div class="app-box-bodyer-video" v-if="currMenusCode === 'hsjn'">
                    <!-- <video controls playsinline autoplay muted loop class="video-box" ref="videoPlayer"
                        src="/video/otc/p-1.mp4"></video> -->
                    <img src="/img/otc/otc-300-1.jpg" class="pro-img pro-img-otc-300-1" />
                </div>
                <div class="app-box-bodyer-video" v-if="currMenusCode === 'fkp'">
                    <!-- <video controls playsinline autoplay muted loop class="video-box" ref="videoPlayer"
                        src="/video/otc/p-1.mp4"></video> -->
                    <img src="/img/otc/k1.jpg" class="pro-img pro-img-k1" />
                </div>


            </div>
            <div class="item part-2" id="block2" ref="block2" :class="{ 'part-2-fixed': part2Fixed }">
                <img src="/img/otc/jin2.jpg" class="pro-img-2 pro-img-2-jin2" v-if="currMenusCode === 'blfhsj'" />
                <img src="/img/otc/jl2.jpg" class="pro-img-2 pro-img-2-jl2" v-if="currMenusCode === 'blfrjn'" />
                <img src="/img/otc/jj2.jpg" class="pro-img-2 pro-img-2-jj2" v-if="currMenusCode === 'blfjjp'" />
                <img src="/img/otc/kl2.jpg" class="pro-img-2 pro-img-2-kl2" v-if="currMenusCode === 'blfkl'" />
                <img src="/img/otc/otc-300-2.jpg" class="pro-img-2 pro-img-2-otc-300-2" v-if="currMenusCode === 'hsjn'" />
                <img src="/img/otc/k2.jpg" class="pro-img-2 pro-img-2-k2" v-if="currMenusCode === 'fkp'" />
            </div>
            <div class="item part-3" id="block3" ref="block3">
                <img src="/img/otc/jin3.jpg" class="pro-img-2 pro-img-3-jin3" v-if="currMenusCode === 'blfhsj'" />
                <img src="/img/otc/jl3.jpg" class="pro-img-2 pro-img-3-jl3" v-if="currMenusCode === 'blfrjn'" />
                <img src="/img/otc/jj3.jpg" class="pro-img-2 pro-img-3-jj3" v-if="currMenusCode === 'blfjjp'" />
                <img src="/img/otc/kl3.jpg" class="pro-img-2 pro-img-3-kl3" v-if="currMenusCode === 'blfkl'" />
                <img src="/img/otc/otc-300-3.jpg" class="pro-img-2 pro-img-3-otc-300-3" v-if="currMenusCode === 'hsjn'" />
                <img src="/img/otc/k3.jpg" class="pro-img-2 pro-img-3-k3" v-if="currMenusCode === 'fkp'" />
            </div>
        </vue-scroll-snap>
    </div>
    <div class="circle-box">
        <div class="">
            <div
                v-for="i in slideCount"
                :key="i"
                :class="['circle', { actived: activeIndex === i - 1 }]"
            ></div>
        </div>
    </div>
    <img src="/img/otc/img-arrow-down.png" class="imgs_arrow" @click="onTap"></img>
    <!-- <div :class="activeIndex >= 1 ? 'btn-weixin' : 'btn-weixin op0'" ref="btn">
        <div class="" id="launch-btn">
            <div class="placeholder">
                <div class="btn-wrapper">
                    <img src="data:image/png;base64,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
" />
                    <div class="tips">测一测</div>
                </div>
            </div>
        </div>
    </div> -->
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import VueScrollSnap from "vue-scroll-snap";
import { getAliyunSigned } from '@/api/service';

const scrollElement = ref(null);
// 图片数据 - 可以根据实际需求替换图片路径
const images = ref([
    { src: '/img/otc/pro-2.png', code: 'blfhsj' },
    { src: '/img/otc/pro-1.png', code: 'hsjn' },
    { src: '/img/otc/pro-5.png', code: 'blfrjn' },
    { src: '/img/otc/pro-4.png', code: 'blfjjp' },
    { src: '/img/otc/pro-3.png',code: 'blfkl' },
    { src: '/img/otc/pro-6.png',code: 'fkp' },
])

// 菜单项数据 - 对应6个图片，每项可配置独立渐变
const menuItems = ref([
    { name: '抗炎镇痛<br/>退烧', code: 'blfhsj', gradient: 'linear-gradient(180deg, #DEBA5F, #D7B04A)' },
    { name: '持续12小时止痛', code: 'hsjn', gradient: 'linear-gradient(180deg, #E9536B, #C31D32)' },
    { name: '快速对抗头痛', code: 'blfrjn', gradient: 'linear-gradient(180deg, #9CD0FA, #72B1F5)' },
    { name: '嚼一嚼<br/>止痛', code: 'blfjjp', gradient: 'linear-gradient(180deg, #FF8502, #FA4644)' },
    { name: '快速缓解痛经', code: 'blfkl', gradient: 'linear-gradient(180deg, #FDB8C4, #FC889B)' },
    { name: '止痛退烧', code: 'fkp', gradient: 'linear-gradient(180deg, #609AD0, #004BA1)' },
])

const selectedIndex = ref(0)

const currMenusCode = ref('blfhsj')

// 选中图片
const selectImage = async (index) => {
    selectedIndex.value = selectedIndex.value === index ? null : index
    const oldCode = currMenusCode.value
    currMenusCode.value = menuItems.value[index].code
    
    // 如果内容发生了变化，需要重新计算滚动位置
    if (oldCode !== currMenusCode.value) {
        // 获取滚动容器
        const getScrollContainer = () => {
            if (!scrollElement.value) return null
            // vue-scroll-snap 可能是组件，尝试访问 $el
            if (scrollElement.value.$el) {
                return scrollElement.value.$el
            }
            // 或者直接是 DOM 元素
            if (scrollElement.value.scrollTop !== undefined) {
                return scrollElement.value
            }
            return null
        }
        
        // 保存当前滚动位置和旧的 block1 高度
        const scrollContainer = getScrollContainer()
        let savedScrollTop = 0
        let oldBlock1Height = 0
        let oldBlock2Height = 0
        if (scrollContainer && block1.value && block2.value) {
            savedScrollTop = scrollContainer.scrollTop
            oldBlock1Height = block1.value.offsetHeight
            oldBlock2Height = block2.value.offsetHeight
        }
        
        // 判断用户之前在哪个 block（1 / 2 / 3）
        let scrollZone = 1
        if (savedScrollTop >= oldBlock1Height + oldBlock2Height - 1) {
            scrollZone = 3
        } else if (savedScrollTop >= oldBlock1Height - 1) {
            scrollZone = 2
        }
        
        // 等待 DOM 更新完成
        await nextTick()
        
        // 等待图片/视频加载完成后再重新计算滚动位置
        setTimeout(() => {
            const container = getScrollContainer()
            if (container && block1.value && block2.value && block3.value) {
                // 强制浏览器重新计算布局
                const newBlock1Height = block1.value.offsetHeight
                const newBlock2Height = block2.value.offsetHeight
                
                // 根据之前的位置决定新的滚动位置
                if (scrollZone === 1) {
                    container.scrollTop = 0
                } else if (scrollZone === 2) {
                    container.scrollTop = newBlock1Height
                } else {
                    container.scrollTop = newBlock1Height + newBlock2Height
                }
                
                // 触发 scroll 事件，让 vue-scroll-snap 重新计算快照点
                container.dispatchEvent(new Event('scroll', { bubbles: true }))
            }
        }, 200) // 给图片/视频一些加载时间
    }
}

const slideCount = 3
const activeIndex = ref(0)
const block1 = ref(null)
const block2 = ref(null)
const block3 = ref(null)

const blockRefs = [block1, block2, block3]

const btn = ref(null);


const checkScroll = (event) => {
    const top = event.target.scrollTop
    let idx = 0
    for (let i = 0; i < blockRefs.length; i++) {
        const block = blockRefs[i].value
        if (!block) continue
        if (top >= block.offsetTop - 8) {
            idx = i
        }
    }
    activeIndex.value = idx
}
const onTap = () => {
    if (scrollElement.value) {
        scrollElement.value.scrollTop = 0;
    }
}
onMounted(() => {
    //getWxConfig();
})
const insertBtn = () => {
    if (btn.value) {
        btn.value.innerHTML = `<wx-open-launch-weapp
        id="launch-btn"
        username="gh_d4b0f39f7133"
        appid="wxf8cfb55d81341236"
        path="pages/index/index">
        <script type="text/wxtag-template">
          <style>
            .placeholder {
                width: 60px;
                height: 60px;
                overflow: hidden;
                border-radius: 50%;
            }

            .placeholder .btn-wrapper {
                width: 60px;
                height: 60px;
                overflow: hidden;
                border-radius: 50%;
                text-align: center;
            }
            .placeholder .btn-wrapper img {
                margin-top: 8px;
                width: 24px;
                height: 24px;
                text-align: center;
            }
            .placeholder .btn-wrapper .tips {
                font-size: 12px;
                text-align: center;
            }
          </style>

          <div class="placeholder">
                <div class="btn-wrapper">
                    <img src="data:image/png;base64,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
" />
                    <div class="tips">测一测</div>
                </div>
          </div>
        <\/script>
      </wx-open-launch-weapp>`;
    }
};
const getWxConfig = () => {
    //获取阿里云签名
    getAliyunSigned().then(response => {
        if (response) {
            // localStorage.setItem('haleon_token', res.access_token)
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
                appId: response.appId, // 必填，公众号的唯一标识
                nonceStr: response.nonceStr, // 必填，生成签名的随机串
                timestamp: response.timestamp, // 必填，生成签名的时间戳
                signature: response.signature,// 必填，签名
                jsApiList: ['chooseImage'], // 必填，需要使用的JS接口列表
                openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
            });

            wx.ready(function () {
                // This will be called when the WeChat JS-SDK is ready
                insertBtn();
            });
        }
    })
}

onUnmounted(() => {
    // 清理
})
</script>

<style lang="scss" scoped>
.btn-weixin {
    width: 60px;
    height: 60px;
    position: fixed;
    bottom: 40px;
    right: 20px;
    opacity: 1;
    background-image: linear-gradient(180deg, #E9536B, #C31D32);
    border-radius: 50%;
    z-index: 99999;

}

.op0 {
    opacity: 0;
}

#launch-btn {
    width: 60px;
    height: 60px;
    color: #fff;
    overflow: hidden;
    border-radius: 50%;
}

.placeholder {
    width: 60px;
    height: 60px;
    overflow: hidden;
    border-radius: 50%;
}

.placeholder .btn-wrapper {
    width: 60px;
    height: 60px;
    overflow: hidden;
    border-radius: 50%;
    text-align: center;
}

.placeholder .btn-wrapper img {
    margin-top: 8px;
    width: 24px;
    height: 24px;
    text-align: center;
}

.placeholder .btn-wrapper .tips {
    font-size: 12px;
    text-align: center;
}



.pro-img {
    width: 100vw;
    margin: 0;
    display: block;
    object-fit: contain;
}

// 根据实际图片尺寸设置宽高比
// jl1.jpg（sips）
.pro-img-jl1 {
    aspect-ratio: 900 / 2112;
}

// jin1.jpg
.pro-img-jin1 {
    aspect-ratio: 1080 / 2024;
}

// jj1.jpg
.pro-img-jj1 {
    aspect-ratio: 1080 / 2276;
}

// kl1.jpg
.pro-img-kl1 {
    aspect-ratio: 1080 / 2398;
}

// otc-300-1.jpg
.pro-img-otc-300-1 {
    aspect-ratio: 1080 / 2567;
}

// k1.jpg
.pro-img-k1 {
    aspect-ratio: 1080 / 1786;
}

.pro-img-2 {
    width: 100vw;
    margin: 0;
    display: block;
    // object-fit: contain;
}

// 根据实际图片尺寸设置宽高比
.pro-img-2-jin2 {
    aspect-ratio: 1080 / 9109;
}

.pro-img-2-jl2 {
    aspect-ratio: 900 / 6270;
}

.pro-img-2-jj2 {
    aspect-ratio: 1080 / 6116;
}

.pro-img-2-kl2 {
    aspect-ratio: 1080 / 5161;
}

.pro-img-2-otc-300-2 {
    aspect-ratio: 1080 / 8870;
}

.pro-img-2-k2 {
    aspect-ratio: 1080 / 7618;
}

.pro-img-3-jin3 {
    aspect-ratio: 1080 / 8008;
}

.pro-img-3-jl3 {
    aspect-ratio: 900 / 7980;
}

.pro-img-3-jj3 {
    aspect-ratio: 1080 / 9161;
}

.pro-img-3-kl3 {
    aspect-ratio: 1080 / 7854;
}

.pro-img-3-otc-300-3 {
    aspect-ratio: 1080 / 8237;
}

.pro-img-3-k3 {
    aspect-ratio: 1080 / 8502;
}

.app-box-bodyer {
    &-info {
        position: relative;

    }

    &-video {
        position: relative;
        width: 100vw;
        // height: calc(100vw * 1.616);


        .video-box {
            // position: absolute;
            width: 100vw;
            height: calc(100vw * 0.56);
            // z-index: 2;
            // left: 0vw;
            // top: 240px;
            // border-radius: 14px;
            
            display: block;
            object-fit: cover;
        }


        .pro-img {
            // position: absolute;
            top: 0;
            width: 100vw;
        }
    }
}

.app-box {
    width: 100vw;
    height: 100vh;
    overflow: hidden;

    &-header {
        width: 100vw;
        background-image: linear-gradient(180deg, #CBCBCB, #eee);

        .bg {
            background-image: url(/img/otc/otc-header-bg.png);
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;

            .logs img {
                width: 90px;
                margin-top: 30px;
                margin-bottom: 10px;
                object-fit: contain;
                // otc-logos.png: 348x93, aspect-ratio: 348/93 = 3.7419
                aspect-ratio: 348 / 93;
            }

            .img-tips {
                width: 100vw;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 20px;

                img {
                    width: 70vw;
                    object-fit: contain;
                    // otc-tips.png: 571x86, aspect-ratio: 571/86 = 6.6395
                    aspect-ratio: 571 / 86;
                }
            }
        }

    }
}

.image-container {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: center;
    padding: 0px 12px;
    margin-bottom: 10px;
}

.image-wrapper {
    flex: 1;
    aspect-ratio: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1),
        opacity 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
    transform-origin: center;
    will-change: transform;
    position: relative;

    // 默认状态 - 正常尺寸
    transform: scale(1);
    opacity: 1;

    // 选中状态 - 放大1.4倍
    &.selected {
        transform: scale(1.4) !important;
        z-index: 10;
        opacity: 1;
    }
}

.image-item {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 12px;

    // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: box-shadow 0.6s cubic-bezier(0.34, 1.56, 0.64, 1),
        border-radius 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
    user-select: none;
    -webkit-user-drag: none;


    .image-wrapper.selected & {
        // box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
        border-radius: 16px;
    }

    .image-wrapper.unselected & {
        // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
}

// 优化动画性能和流畅度
.image-container {
    perspective: 1000px;
    transform-style: preserve-3d;
}

.image-wrapper {
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    transform-style: preserve-3d;
}

// 当有图片被选中时，未选中的图片缩小到0.8倍
.app-box.has-selected .image-wrapper:not(.selected) {
    transform: scale(1) !important;
    opacity: 0.85;
}

// 添加hover效果，提升交互体验（仅在无选中状态时生效）
.app-box:not(.has-selected) .image-wrapper:hover {
    transform: scale(1.05);
}

// 菜单容器样式
.menu-container {
    display: flex;
    width: 100%;
    max-width: 1200px;
    align-items: flex-end;
    justify-content: center;
    height: 64px;

    // padding: 0 20px;
}

// 菜单项样式（渐变由 menuItems[].gradient 配置，此处不写死）
.menu-item {
    flex: 1;
    // padding: 16px 12px;
    text-align: center;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    transition: all 0.3s ease;
    user-select: none;
    height: 44px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;


    &:hover {
        //background-color: #E9536B;
        // transform: translateY(-2px);
    }

    &.selected {
        //background-color: #E9536B;
        color: #ffffff;
        height: 58px;
        font-weight: 600;
    }
}

.circle-box {
    width: 18px;
    position: fixed;
    left: 20px;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    top: 0px;
    pointer-events: none;

    .circle {
        width: 10px;
        height: 10px;
        background-color: #eee;
        border-radius: 5px;
        margin-bottom: 10px;
    }

    .actived {
        background-color: red;
    }
}

.imgs_arrow {
    width: 44px;
    height: 44px;
    position: fixed;
    bottom: 20px;
    left: calc((100vw - 44px) / 2);
    animation: bounce 2s ease-in-out infinite;
}

.scroll-snap-container {
    height: 100vh;
    width: 100vw;
}

@keyframes bounce {

    0%,
    100% {
        transform: translateY(0);
    }

    25% {
        transform: translateY(-20px);
    }

    50% {
        transform: translateY(10px);
    }

    75% {
        transform: translateY(-5px);
    }
}
</style>